import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';
import { NewFaseEstrategicaModel } from '../model/NewFaseEstrategica.model';
import { AniosPMEModel, NewFaseAnual } from '../model/NewFaseAnual.model';

//pme
const pme = 'pme/getPlanMejora/';
//fase estratejica
const faseEstrategica = 'pme/getFaseEstrategica/';
const saveFaseEstrategica = 'pme/saveFaseEstrategica/';
const finishFaseEstrategica = 'pme/finishFaseEstrategica/';
//fase anual
const getFaseAnual = 'pme/getFaseAnual/';
const saveFaseAnual = 'pme/saveFaseAnual/';
const finishFaseAnual = 'pme/finishFaseAnual/';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};  

@Injectable({
  providedIn: 'root'
})
export class NewPlanMejoraService {


  constructor(private http:HttpClient,private storageService: StorageService) { }


  API_GET_getNewPlanMejora(idJardinPeriodo: number) {
    return this.http.get(environment.apiEndpoint + pme + idJardinPeriodo, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
   //Fase Estrategica
  API_GET_getFaseEstrategica(idJardinPeriodo: number) {
    return this.http.get(environment.apiEndpoint + faseEstrategica + idJardinPeriodo, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_guardarFaseEstrategica(idJardinPeriodo: number, faseEstrategicaData: NewFaseEstrategicaModel) {
    return this.http.post(environment.apiEndpoint + saveFaseEstrategica + idJardinPeriodo, faseEstrategicaData, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_finalizarFaseEstrategica(idJardinPeriodo: number, faseEstrategicaData: NewFaseEstrategicaModel) {
    return this.http.post(environment.apiEndpoint + finishFaseEstrategica + idJardinPeriodo, faseEstrategicaData, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  //Fase Anual

  API_GET_getFaseAnual(idJardinPeriodo: number) {
    return this.http.get(environment.apiEndpoint + getFaseAnual + idJardinPeriodo, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_guardarFaseAnual(idJardinPeriodo: number, faseAnualData: AniosPMEModel) {
    return this.http.post(environment.apiEndpoint + saveFaseAnual + idJardinPeriodo, faseAnualData, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  
  API_POST_finalizarFaseAnual(idJardinPeriodo: number, faseAnualData: AniosPMEModel) {
    return this.http.post(environment.apiEndpoint + finishFaseAnual + idJardinPeriodo, faseAnualData, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  handleError(error) {    
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
    return throwError(errorMessage);
  }

}
